import { KeyboardEvent } from "react";

/**
 * An onKeyDown handler that only executes the callback when Enter key is pressed
 */
export const onEnterKey = <T extends Element = Element>(
  callback: (event: KeyboardEvent<T>) => void,
): ((event: KeyboardEvent<T>) => void) => {
  return (event: KeyboardEvent<T>) => {
    if (event.key === "Enter") {
      callback(event);
    }
  };
};
